export default __webpack_public_path__ + "static/assets/9bfae102ff181c07bad58c39541da884.jpg";